import React, {useState, useEffect, useCallback} from 'react';
import { httpGet } from '../shared/Config';
import { Button } from 'reactstrap';
import Section from '../shared/Section'
import SubscribeModal from './SubscribeModal';
import DateFormat from '../shared/DateFormat'
import moment from 'moment';
import ConfirmationModal from '../shared/ConfirmationModal';
import SectionList from '../shared/SectionList'

import { useTranslation } from 'react-i18next';

function AlternateStorageSubscription() {
    const {t} = useTranslation();
    const [pendingLockingDocumentsPayments, setPendingLockingDocumentsPayments] = useState();   
    const [tenant, setTenant] = useState({});

    const [subscriptionInfo, setSubscriptionInfo] = useState({});
    const [subFetch, setSubFetch] = useState(false);
    const [showCancelConfModal, setShowCancelConfModal] = useState(false);
    const [showReactivateConfModal, setShowReactivateConfModal] = useState(false);

    const [organizations, setOrganizations] = useState(null)
    
    useEffect(() => {
        async function fetchSubinfo() {
            try {
                const tenant = await httpGet(`/getTenant`);
                let conf = JSON.parse(tenant.data.data.configuration);
                setTenant(conf);
                console.log(conf);

                const subscriptionFetch = await httpGet(`/subscription/EXTERNAL_STORAGE_SUBSCRIPTION/getSubscriptionInfo`);
                if(subscriptionFetch.data) {
                    if(subscriptionFetch.data.subInfo?.id) {
                        setSubscriptionInfo(subscriptionFetch.data.subInfo);

                        if(subscriptionFetch.data.subInfo?.active) {
                            try {
                                const response = await httpGet('/subscription/EXTERNAL_STORAGE_SUBSCRIPTION/getOrganizations');
                                let corporativeFound = 0;
                                for(let plan of response.data) {
                                    if(plan.plan.id === 3 || plan.plan.id === 2) {
                                        corporativeFound++;
                                    }
                                }
                                setOrganizations(response.data);
                            } catch(e) {
                                console.error(e);
                                setOrganizations([]);
                            }
                        }
                    } else if(subscriptionFetch.data.error) {
                        console.log(subscriptionFetch.data.error);
                    }
                } else {
                    // no subscription found for this type
                }
                setSubFetch(true);
            } catch(e) {
                console.log(e);
            }
        }

        fetchSubinfo();
    }, []);

    /*useEffect(() => {
        if(organizations) {
        for(let org of organizations) {
            fetchConfiguration(org.organization.id);
        }
        }
    }, [organizations]);*/

    const fetchPendingPayments = useCallback(async () => {
        const responseDocuments = await httpGet('/payments/checkIfPendingPayments/DOCUMENTS');
        if(responseDocuments){
            setPendingLockingDocumentsPayments(responseDocuments.data.data.pending);
        }
    },[]);

    const [subscriptionModal, setSubscriptionModal] = useState({
        open: false
    });

    function openSubscriptionModal() {
        setSubscriptionModal({open:true});
    }

    function onCancel() {
        setSubscriptionModal({open:false});
    }

    function toggleCancelConfModal() {
        setShowCancelConfModal(!showCancelConfModal);
    }
    
    function cancelCancelConfModal() {
        setShowCancelConfModal(false);
    }

    function confirmCancelConfModal() {       
         async function cancelSubscriptionFetch() {
            try {
                const subscriptionFetch = await httpGet(`/subscription/EXTERNAL_STORAGE_SUBSCRIPTION/cancelSubscription`);

                if(subscriptionFetch) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } catch(e) {
                console.log(e);
            }
        }

        cancelSubscriptionFetch();
    }

    
    function toggleReactivateConfModal() {
        setShowReactivateConfModal(!showCancelConfModal);
    }

    
    function cancelReactivateConfModal() {
        setShowReactivateConfModal(false);
    }

    function confirmReactivateConfModal() {       
        async function reactiveCurrentSubscriptionFetch() {
            try {
                const subscriptionFetch = await httpGet(`/subscription/EXTERNAL_STORAGE_SUBSCRIPTION/reactivateSubscription`);
                if(subscriptionFetch) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } catch(e) {
                console.log(e);
            }
        }

        reactiveCurrentSubscriptionFetch();
    }


    function fetchConfiguration(organizationId) {
        async function fetchConfiguration() {
            try {
                const configurationMetaFetch = await httpGet(`/subscription/${organizationId}/getConfiguration`);
                if(configurationMetaFetch) {
                    let g = 5 + 5;
                }
            } catch(e) {
                console.log(e);
            }
        }

        fetchConfiguration();
    }

    function configureAlternateStorage(organizationId) {
        async function configureAlternateStorageFetch() {
            try {
                const configurationFetch = await httpGet(`/subscription/${organizationId}/configureDepartment`);
                if(configurationFetch) {
                    if(configurationFetch.data.urlGrantConsent){
                        window.open(configurationFetch.data.urlGrantConsent, '_blank').focus();
                    }
                }
            } catch(e) {
                console.log(e);
            }
        }

        configureAlternateStorageFetch();
    }

    function onComplete() {
        window.location.reload();
    }

    return (
        <div>
            <h2>
                <b>{t('SUBSCRIPTIONS')}</b>
            </h2>
            <Section>
                <div lassName="row justify-content-around">
                    <div>{t('ALTERNATE_STORAGE_TITLE')}</div>
                    <br/>
                    {
                        subFetch ? <React.Fragment>
                            {
                                subscriptionInfo.id ? <React.Fragment>
                                    {
                                        subscriptionInfo.active ? 
                                        <React.Fragment>
                                            {t('SUBSCRIPTION_ACTIVE')}                    
                                            <br/>
                                            {t('SUBSCRIPTION_START_DATE')}: <DateFormat>{moment(subscriptionInfo.dateSubscriptionStarts)}</DateFormat>
                                            <br/> 
                                            {t('MODE')}   : {subscriptionInfo.subscriptionPayMethod}
                                            <br/>
                                            {
                                                subscriptionInfo.dateSubscriptionEnds ?  
                                                <React.Fragment>
                                                    {t('SUBSCRIPTION_START_END')}: <DateFormat>{moment(subscriptionInfo.dateSubscriptionEnds)}</DateFormat> 
                                                    <br/>
                                                </React.Fragment> : null
                                            }
                                        </React.Fragment> : 
                                        <React.Fragment>
                                            {t('SUBSCRIPTION_INACTIVE')}
                                            <br/>
                                            {
                                                subscriptionInfo.status === "CANCELLED" || (subscriptionInfo.subscriptionPayMethod === "STRIPE" && !subscriptionInfo.stripeSubscriptionId) ?
                                                <React.Fragment>
                                                <Button color="primary" onClick={openSubscriptionModal}>{t('SUBSCRIBE')}</Button>
                                                <br/>
                                                <SubscribeModal 
                                                        isOpen={subscriptionModal.open} 
                                                        onCancel={onCancel}
                                                        askFacturacion={false}
                                                        existingSubscription={subscriptionInfo}
                                                        subscriptionType="EXTERNAL_STORAGE_SUBSCRIPTION"
                                                        tenant={tenant}
                                                        onComplete={onComplete}
                                                        title="ALTERNATE_STORAGE_TITLE"
                                                    />    
                                                <br/>
                                                </React.Fragment> : null 
                                            }
                                        </React.Fragment>
                                    }
                                    <br/>
                                    <br/>
                                    {
                                        (subscriptionInfo.subscriptionPayMethod === "SPEI" && subscriptionInfo.status === "PENDING_SPEI") ? <React.Fragment>
                                            {t('PAYMENT_LIMIT_DATE')}: <DateFormat>{moment(subscriptionInfo.dueDate)}</DateFormat>                            
                                            <br/>
                                            {t('SPEI_LIMIT_15_DAYS')}
                                            <br/>
                                        </React.Fragment> : null
                                    }
                                    {
                                        subscriptionInfo.status === "PAST_DUE" ? <React.Fragment>
                                            {t('PENDING_SUBSCRIPTION_PAYMENT')}
                                            <br/>
                                        </React.Fragment> : null
                                    }
                                    {
                                        subscriptionInfo.status === "PENDING_SPEI" || subscriptionInfo.status === "ACTIVE" || subscriptionInfo.status === "ACTIVE_NO_RENEWAL" ? <React.Fragment>
                                        <br/>
                                            {t('DEPARTMENTS')}
                                            <SectionList collection={organizations}
                                                    noData={<p>{t('NONE')}</p>}>
                                            {
                                                organizations && organizations.map(org => (
                                                    <div key={org.organization.id}>
                                                        <p style={{fontWeight: 'bold'}}>{org.organization.organizationName}</p>
                                                        <Button disabled={!subscriptionInfo.active} color="primary" onClick={() => configureAlternateStorage(org.organization.id)}>{t('ADDITIONAL_CONFIGURATION')} '{org.organization.organizationName}'</Button>
                                                        <br/>
                                                        {
                                                            org.subResponse.error ? <React.Fragment>{org.subResponse.error}</React.Fragment> : null
                                                        }
                                                        {
                                                            org.subResponse.tenantId ? <React.Fragment>{t('CONFIGURATION_FOUND')}: {org.subResponse.structureStorage}</React.Fragment> : null
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </SectionList>
                                        </React.Fragment> : null
                                    }
                                    {
                                        subscriptionInfo.status === "ACTIVE" ? <React.Fragment>
                                        <Button color="primary" onClick={toggleCancelConfModal}>{t('CANCEL_SUBSCRIPTION')}</Button>
                                        <br/>            
                                        <ConfirmationModal isOpen={showCancelConfModal}
                                            onCancel={cancelCancelConfModal}
                                            onOk={confirmCancelConfModal}
                                            title="CANCEL_SUBSCRIPTION">
                                                <span>{t('CANCEL_SUBSCRIPTION_NOTICE_1')}</span>
                                                <br/>
                                                <p>{t('CONTINUE_QUESTION')}</p>
                                        </ConfirmationModal>
                                        </React.Fragment> : null
                                    }
                                    {
                                        subscriptionInfo.status === "ACTIVE_NO_RENEWAL" ? <React.Fragment>
                                            <br/>
                                            {t('REACTIVATE_SUBSCRIPTION_NOTICE_1')}
                                            <br/>
                                            <Button color="primary" onClick={toggleReactivateConfModal}>{t('REACTIVATE_SUBSCRIPTION')}</Button>
                                            <br/>                                
                                            <ConfirmationModal isOpen={showReactivateConfModal}
                                                onCancel={cancelReactivateConfModal}
                                                onOk={confirmReactivateConfModal}
                                                title="REACTIVATE_SUBSCRIPTION">
                                                    <span>{t('REACTIVATE_SUBSCRIPTION_NOTICE_2')}</span>
                                                    <br/>
                                                    <p>{t('CONTINUE_QUESTION')}</p>
                                            </ConfirmationModal>
                                        </React.Fragment> : null
                                    }
                                </React.Fragment> : 
                                <React.Fragment>
                                    <p>{t('NO_ACTIVE_SUBSCRIPTION')}</p>
                                    <br/>
                                    <div>
                                        <div className="col">
                                            <div className="row justify-content-start">
                                                <Button color="primary" onClick={openSubscriptionModal}>{t('SUBSCRIBE')}</Button>
                                                <SubscribeModal 
                                                    isOpen={subscriptionModal.open} 
                                                    onCancel={onCancel}
                                                    pendingPayments={pendingLockingDocumentsPayments} 
                                                    askFacturacion={false}
                                                    existingSubscription={subscriptionInfo}
                                                    subscriptionType="EXTERNAL_STORAGE_SUBSCRIPTION"
                                                    tenant={tenant}
                                                    onComplete={onComplete}
                                                    title="ALTERNATE_STORAGE_TITLE"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                        </React.Fragment> : <React.Fragment>{t('LOADING_SUBSCRIPTION_DATA')}</React.Fragment>
                    }
                </div>
            </Section>
        </div>
    )
}

export default AlternateStorageSubscription;